// ============================================================
// parkApi.js — Fonctions d'appel API partagées
// Centralisées ici pour éviter la duplication entre
// calls.js (liste) et MapApp.js (carte).
// Chaque fonction retourne une Promise résolue après la
// réponse du serveur, laissant les composants gérer
// les callbacks de succès (fermeture modale, refresh...).
// ============================================================

import axios from 'axios';

// Valide le contrôle d'un parc (POST /setControled/date/:id)
// exitStandby = true : sort aussi le parc du mode standby
export const apiSetControled = (authtoken, id, ControlDate, userControlId, exitStandby = false) =>
    Promise.resolve(authtoken).then(token =>
        axios.post('/setControled/date/' + id, { date: ControlDate, userControlId, exitStandby },
            { headers: { Authorization: `Bearer ${token}` } })
    );

// Bascule l'état standby d'un parc (POST /setStandby/:id)
export const apiSetStandby = (authtoken, id) =>
    Promise.resolve(authtoken).then(token =>
        axios.post('/setStandby/' + id, {},
            { headers: { Authorization: `Bearer ${token}` } })
    );

// Supprime définitivement un parc (POST /delete/:id)
export const apiDeletePark = (authtoken, id) =>
    Promise.resolve(authtoken).then(token =>
        axios.post('/delete/' + id, {},
            { headers: { Authorization: `Bearer ${token}` } })
    );
